import { isEqual } from "es-toolkit";
import { useRef } from "react";
import { useShallow } from "zustand/shallow";

export const useShallowDeep = <S, U>(
  selector: (state: S) => U,
): ((state: S) => U) => {
  const prev = useRef<U>(undefined);

  return useShallow((state) => {
    const next = selector(state);

    if (prev.current === undefined || isEqual(prev.current, next) === false) {
      prev.current = next;
    }

    return prev.current;
  });
};
